/* Shopify multipart uploads are retained. A private request marker lets a retry
   reconcile an uncertain/partial response before it sends another add request. */
(function (scope) {
  function createCartRequest({ fetch: request, root = '/', storage, key, onState = () => {} }) {
    let saved;
    try { saved = JSON.parse(storage?.getItem(key) || 'null'); } catch (_) {}
    const age = Date.now() - saved?.created;
    let state = saved && typeof saved.id === 'string' && Number.isFinite(age) && age >= 0 && age < 30 * 60 * 1000 ? saved : null;
    let running = false;
    const persist = () => {
      try { storage?.setItem(key, JSON.stringify(state)); } catch (_) {}
      onState({ ...state });
    };
    const reconcile = async () => {
      const response = await request(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('We could not check your bag. Open it below before trying again.');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('We could not check your bag. Please open it below.');
      state.main = cart.items.some((item) => item.properties?._wote_request === `${state.id}:main`);
      state.booster = cart.items.some((item) => item.properties?._wote_request === `${state.id}:booster`);
      persist();
    };
    return {
      getState: () => state ? { ...state } : null,
      complete() {
        // Completed navigation should not suppress a separate future order.
        // Keep this document's marker for a back-forward cache return only.
        try { storage?.removeItem(key); } catch (_) {}
      },
      startNew() {
        if (running) return false;
        state = null;
        try { storage?.removeItem(key); } catch (_) {}
        onState({ main: false, booster: false });
        return true;
      },
      async run({ getFormData, boosterId }) {
        if (running) return { busy: true };
        running = true;
        try {
          if (state?.attempted) await reconcile();
          if (!state) {
            state = { id: scope.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`, created: Date.now(), main: false, booster: false, attempted: false };
          }
          if (!state.main) {
            const body = getFormData();
            body.set('properties[_wote_request]', `${state.id}:main`);
            state.attempted = true;
            persist();
            const response = await request(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
            if (!response.ok) {
              const problem = await response.json().catch(() => ({}));
              throw new Error(problem.description || 'This order could not be added. Please try again.');
            }
            state.main = true;
            persist();
          }
          if (boosterId && !state.booster) {
            const response = await request(`${root}cart/add.js`, {
              method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(boosterId), quantity: 1, properties: { _Bundle: 'Personalized ritual booster', _wote_request: `${state.id}:booster` } }] })
            });
            if (!response.ok) throw new Error('Your main order is in your bag. The optional booster could not be added. Retry the booster, or continue to your bag without it.');
            state.booster = true;
            persist();
          }
          return { main: state.main, booster: state.booster };
        } catch (problem) {
          if (problem instanceof TypeError) throw new Error('The connection was interrupted. Your bag will be checked before a retry, so the same order is not added twice.');
          throw problem;
        } finally { running = false; }
      }
    };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { createCartRequest };
  else scope.WoteCart = { createCartRequest };
})(typeof window !== 'undefined' ? window : globalThis);
